<div class="paginator-container" [ngStyle]="{ 'justify-content': position }">
  <button mat-icon-button color="accent" [disabled]="paginationClickedCount === 1" (click)="prevPage()">Last</button>
  <span class="paginator-label">Page {{ paginationClickedCount }}</span>
  <button mat-icon-button color="accent" [disabled]="disableNext" (click)="nextPage()">Next</button>
</div>
